import { useSelector } from 'react-redux';

import { selectUserInfo } from '@app/redux';
import { selectConfig } from '@app/redux/config';

export const useShouldShowClickToDisconnect = () => {
  const { disconnectRegions } = useSelector(selectConfig);
  const {
    userInfo: {
      address: { service },
    },
  } = useSelector(selectUserInfo);

  if (!service?.region) {
    return false;
  }

  return disconnectRegions.includes(service.region);
};
